module.exports = __webpack_public_path__ + "img/instr_1.349d2306.svg";